import React from 'react';
import BalletVariationQuiz from '../components/BalletVariationQuiz/BalletVariationQuiz';

const Quiz = () => {
  return (
    <div className="page-container">
      <BalletVariationQuiz />
    </div>
  );
};

export default Quiz; 